import { defineStore } from "pinia";
import rawModules from "../assets/mocks/sidebar-modules.json";

interface ModuleItem {
  id: string;
  name: string;
}

interface ModuleGroup {
  title: string;
  items: ModuleItem[];
}

interface ModuleDefinition {
  name: string;
  icon: string;
  disabled?: boolean;
  groups?: ModuleGroup[];
  subSections?: ModuleItem[];
}

const modules = rawModules as Record<string, ModuleDefinition>;
if (import.meta.env.VITE_MP_ENABLED === "true") {
  modules.marketplace.disabled = false;
}

export const useSidebarStore = defineStore("sidebar", {
  state: () => ({
    activeModule: null as string | null,
    activeSubModule: null as string | null,
    lastActiveSubModules: {} as Record<string, string | null>,
    modules,
  }),

  actions: {
    setActiveModule(module: string | null) {
      if (module && this.modules[module]) {
        this.activeModule = module;

        const firstGroupItemId = this.modules[module].groups?.[0]?.items?.[0]?.id;
        const firstSubSectionId = this.modules[module].subSections?.[0]?.id;

        this.activeSubModule = this.lastActiveSubModules[module] ?? firstGroupItemId ?? firstSubSectionId ?? null;
      } else {
        this.activeModule = null;
        this.activeSubModule = null;
      }
    },
    setActiveSubModule(subModule: string | null) {
      this.activeSubModule = subModule;
      if (this.activeModule) {
        this.lastActiveSubModules[this.activeModule] = subModule;
      }
    },
  },
});
